import axios from 'axios';

export async function getSignupUserDetails(data: any) {
  try {
    const iamUrl = process.env.REACT_APP_IAM_API_URL;
    const response = await axios.get(
      `${iamUrl}/public-users/${data.orgId}/invitation/verify/${data.ticketId}`,
      {
        headers: {
          'accept': 'application/json',
        },
      }
    );

    return {
      data: response.data,
    };
  } catch (err) {
    return {
      data: err,
    };
  }
}

export const createAccount = async (data: any, userData: any) => {
  try {
    const iamUrl = process.env.REACT_APP_IAM_API_URL;
    const response = await axios.post(
      `${iamUrl}/public-users/${data.orgId}/invitation/verify/${data.ticketId}`,
      userData,
      {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json',
        },
      }
    );

    return {
      data: response.data,
    };
  } catch (err) {
    return {
      data: err,
    };
  }
};

export const imageFileUpload = async (
    file: any,
    fileName?: string
): Promise<{ publicUrl: string }> => {
    const formData = new FormData();
    if (fileName) {
        formData.append('file', file, fileName);
    } else {
        formData.append('file', file);
    }

    const token = localStorage.getItem('authToken');

    try {
        const damUrl = process.env.REACT_APP_DAM_API_URL;
    const response = await axios.post(
            `${damUrl}/files/upload`,
            formData,
            {
                headers: {
                    'Authorization': `Bearer ${token}`,
                },
            }
        );
        return response.data;
    } catch (err: any) {
        return err;
    }
};